import { render, staticRenderFns } from "./FamilyUserSettings.vue?vue&type=template&id=c3c63eda&scoped=true&"
import script from "./FamilyUserSettings.vue?vue&type=script&lang=js&"
export * from "./FamilyUserSettings.vue?vue&type=script&lang=js&"
import style0 from "./FamilyUserSettings.vue?vue&type=style&index=0&id=c3c63eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c63eda",
  null
  
)

export default component.exports